import React, { Component } from "react"
import { Formik, Field, Form } from "formik"
import * as Yup from "yup"
import config from "../common/config.json"
import http from "../../services/httpService"
import Phone from "../common/phoneInput"

const ContactSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Name is Required"),
  companyname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Company Name is Required"),
  email: Yup.string()
    .email("Invalid email")
    .required("Email is Required"),
  phone: Yup.string().required("Please Enter Your Phone Number"),
  message: Yup.string()
    .min(3, "Too Short!")
    .required("Message is Required"),
})

class ContactForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      feedback: false,
      errorMsg: false,
      isSending: false,
    }
  }

  handleSubmit = async (values, { resetForm }) => {
    this.setState({ isSending: true })
    console.log("vales are :", values)

    const subject = `${values.name} < New Message From Morosoft Website >`

    const htmlvalues = `
            <p><strong>Name: </strong> ${values.name}</p>
            <p><strong>Company Name: </strong> ${values.companyname}</p>
            <p><strong>Email: </strong> ${values.email}</p>
            <p><strong>Phone: </strong> ${values.phone}</p>
            <p><strong>Message: </strong> ${values.message}</p> `

    try {
      await http.post(config.emailEndpoint, {
        to: "sales@morosoft.org",
        subject: subject,
        html: htmlvalues,
      })

      resetForm()
      this.setState({ isSending: false, feedback: true })
    } catch (ex) {
      resetForm()
      this.setState({ errorMsg: true, isSending: false })
    }
  }

  render() {
    return (
      <React.Fragment>
        <Formik
          initialValues={{
            name: "",
            companyname: "",
            email: "",
            phone: "",
            message: "",
          }}
          validationSchema={ContactSchema}
          onSubmit={this.handleSubmit}
        >
          {({ errors, touched }) => (
            <Form>
              <div className="form-group">
                <Field
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  className={
                    errors.name && touched.name
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                />
                {errors.name && touched.name ? (
                  <div className="invalid-feedback">{errors.name}</div>
                ) : null}
              </div>

              <div className="form-group">
                <Field
                  type="text"
                  name="companyname"
                  className={
                    errors.companyname && touched.companyname
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Your Company Name"
                />
                {errors.companyname && touched.companyname ? (
                  <div className="invalid-feedback">{errors.companyname}</div>
                ) : null}
              </div>

              <div className="form-group">
                <Field
                  type="email"
                  name="email"
                  className={
                    errors.email && touched.email
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Your Email"
                />
                {errors.email && touched.email ? (
                  <div className="invalid-feedback">{errors.email}</div>
                ) : null}
              </div>

              <div className="form-group">
                <Field name="phone" component={Phone} />
              </div>

              <div className="form-group">
                <Field
                  component="textarea"
                  name="message"
                  className={
                    errors.message && touched.message
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                  placeholder="Your Message"
                  rows="4"
                />
                {errors.message && touched.message ? (
                  <div className="invalid-feedback">{errors.message}</div>
                ) : null}
              </div>

              {this.state.errorMsg && (
                <div className="feedback-container text-danger">
                  <p>Something went wrong please try again.</p>
                </div>
              )}

              {this.state.feedback && (
                <div className="feedback-container text-danger">
                  <h5>Thank you.!!!</h5>
                  <p>
                    Your messsage have been received. we will contact you
                    shortly.
                  </p>
                </div>
              )}

              <div className="form-group">
                <button
                  type="submit"
                  disabled={this.state.isSending}
                  className="form-btn"
                >
                  {this.state.isSending && (
                    <i className="fa fa-refresh fa-spin" />
                  )}{" "}
                  {this.state.isSending && <span>Sending....</span>}
                  {!this.state.isSending && <span> Send Message</span>}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </React.Fragment>
    )
  }
}

export default ContactForm
